import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AwsSchedulerService {
    public apiBaseUrl: any;
    public schedulerType:any;
    public scheduleStopReason:any;

    constructor(private httpClient: HttpClient,private apiService: ApiService) {
        this.apiBaseUrl = environment.SERVER_ROOT_URL

    }

    getClientNames() {
        return this.httpClient.get(this.apiBaseUrl + '/api/file-processing/get-client-data')
    }

    getBrands(clientKey: any) {
        return this.httpClient.post(this.apiBaseUrl + '/api/filter/get-brand-region-filter', { client_key: clientKey })
    }

    getSchedulerList(req: any) {
        return this.httpClient.post(this.apiBaseUrl + '/api/filter/get-schedlue-filter', req)
    }


    getSchedulerDataByName(req: any) {
        return this.httpClient.post(this.apiBaseUrl + '/api/Scheduler/get-schedule-data', req)
    }

    getActiveScheduler(userId:any) {
        return this.apiService.post( 'api/Scheduler/get-active-schedule-data', userId)
    }

    updateActiveSchedulers(req: any) {
        return this.apiService.post( 'api/Scheduler/update-schedule-data', req)
    }

    deleteActiveScheduler(req: any) {
        return this.apiService.post('api/Scheduler/delete-schedule-data', req)
    }

}
